var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Check-Circle",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#218751"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9 0L3.75 9.5 0 5.5",
    transform: "translate(5.5 5.056)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocSign);
export default __webpack_public_path__ + "static/media/icon-doc-sign.e31febf97d0cde917357d41818fd903e.svg";
export { ForwardRef as ReactComponent };